import React from 'react';
const IconNavFolderFill = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M22 5H12.47L10.79 3H2V21H22V5Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconNavFolderFill;